import angular from 'angular';

import Component from './event-details.component';

const EventDetails = angular
    .module('control-room.events.components.event-details', [])
    .component('crEventDetails', Component);

export default EventDetails;
